import React, { FunctionComponent } from 'react';
import { Card, Form, message, Tabs, Tooltip } from 'antd';

import { IAppComponentProps } from '../../components';
import SurveyAgreements from './surveyAgreements/survey-agreements.component';
import { useIntl } from 'react-intl';
import { StateContainer } from './utilities/StateContainer';
import { Link } from 'react-router-dom';
import { getI18n } from '../../utils/Utils';
import { HomeOutlined } from '@ant-design/icons';
import styling from './styling/survey.module.css';

type ISurveyInvoiceAgreementStepProps = {
    agreementTypeId?: number;
    groupId?: string;
    next?: any;
    prev?: any;
    onStatusUpdate?: any;
    stateContainer?: StateContainer;
} & IAppComponentProps;

const SurveyInvoiceAgreementStep: FunctionComponent<ISurveyInvoiceAgreementStepProps> = (props) => {
    const intl = useIntl();
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    const agreementData = {
        approverName: '',
        approverEmail: '',
        agreementStatusId: undefined,
        agreementDocId: undefined,
        agreementStatusDate: undefined,
        formValuesChanged: false,
    };

    const handleNextClick = () => {
        if (agreementData.formValuesChanged) {
            message.error(
                intl.formatMessage({
                    id: 'agreement-dataChangedSaveFailure',
                    defaultMessage: 'Form values changed, save first',
                })
            );
        } else {
            props.next();
        }
    };

    const handlePrevClick = () => {
        if (agreementData.formValuesChanged) {
            message.error(
                intl.formatMessage({
                    id: 'agreement-dataChangedSaveFailure',
                    defaultMessage: 'Form values changed, save first',
                })
            );
        } else {
            props.prev();
        }
    };

    return (
        <>
            <Card
                title={
                <>
                     <span style={{ marginRight: '20px', marginTop: '20px' }}>
                    <Link to={'/survey/survey-overview'}>
                        <Tooltip
                            title={getI18n(
                                'survey-master-data-partner-tab-back-icon-tool-tip',
                                'Return to Survey Overview Page',
                                intl
                            )}
                            key={'keyCancelInvoiceIcon'}
                        >
                            <HomeOutlined
                                style={{ fontSize: '25px', cursor: 'pointer', color: '#024051', marginTop: '15px' }}
                            />
                        </Tooltip>
                    </Link>
                </span>
                <span>{intl.formatMessage({
                    id: 'agreement-tab-title',
                    defaultMessage: 'eInvoice Agreement',
                })}
                </span>
                </>
            }
                size={'small'}
                className={`ml-10 ml25 ${styling.removeUnderLine}`}
            >
                <SurveyAgreements
                    form={form}
                    agreementData={agreementData}
                    agreementTypeId={props.agreementTypeId}
                    groupId={props.groupId}
                    onStatusUpdate={props.onStatusUpdate}
                    {...props}
                />
            </Card>
        </>
    );
};

export default SurveyInvoiceAgreementStep;
